import { IChannel } from '@dtos/Channel'
import { formatDateShort } from '@utils/dateFormatter'
import { router } from 'expo-router'
import { Pressable } from 'react-native'
import { Text, View, XStack, YStack } from 'tamagui'

interface IChannelCardProps {
  channel: IChannel
}

export function ChannelCard({ channel }: IChannelCardProps) {
  const preview = channel.lastMessage?.text ?? ''
  const date = channel.lastMessage?.createdAt ?? channel.updatedAt

  return (
    <Pressable
      onPress={() => router.push(`/channels/${channel.id}`)}
      testID={`channel-card-${channel.id}`}
    >
      <YStack
        gap="$spacing-inset-nano"
        p="$spacing-inset-md"
        borderRadius="$border-radius-md"
        backgroundColor="$bg-surface"
      >
        <XStack alignItems="center" gap="$spacing-inset-xs">
          {channel.unread && (
            <View
              width={8}
              height={8}
              borderRadius={4}
              backgroundColor="$accent"
              testID={`channel-card-unread-${channel.id}`}
            />
          )}
          <Text
            fontFamily="$mulishBold"
            fontSize="$font-size-xs"
            color="$text-primary"
            fontWeight="bold"
            numberOfLines={1}
            flex={1}
          >
            {channel.subject}
          </Text>
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxxs"
            color="$text-placeholder"
          >
            {formatDateShort(date)}
          </Text>
        </XStack>
        {!!preview && (
          <Text
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxs"
            color="$text-placeholder"
            numberOfLines={2}
          >
            {preview}
          </Text>
        )}
      </YStack>
    </Pressable>
  )
}
